import axios from '@/settings/axios'
import { apiSettings } from "@/settings/api"

let base = '/payment/';
export default {
    getTarifs(version = apiSettings.payment_ver) {
        return axios.get(base + version + '/tariffs');
    },
    transaction(request = { "amount": "", "pay_type_id": "" }, version = apiSettings.payment_ver) {
        return axios.post(base + version + '/transactions', request);
    },
    getPayType(version = apiSettings.payment_ver) {
        return axios.get(base + version + '/paytypes');
    },
    getBalance(version = apiSettings.payment_ver) {
        return axios.get(base + version + '/balance');
    },
    history(request = { page: 1, limit: 15, start_date: '', finish_date: '', operation: '' }, version = apiSettings.payment_ver) {
        return axios.get(base + version + '/transactions/history', { params: request });
    }
}